module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-7.5b310d45.png";